/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_Define from 'canvas/base/dev/util/B_Define';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_Shape from 'canvas/base/dev/child/shape/B_Shape';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

let mix = (superclass) => new MixinBuilder(superclass);

class B_Grid extends mix(B_Real).with(B_ChildWorld, B_Shape) {
		constructor(obj) {
			super(obj);

			if (obj.lineColor) this._lineColor = obj.lineColor;
			if (obj.lineSize) this._lineSize = obj.lineSize;
			if (obj.bgColor) this._bgColor = obj.bgColor;

			// [S] row & column
			if (obj.row) this._row = obj.row;
			if (obj.column) this._column = obj.column;

			// [S] lenX, lenY
			if (this._w && this._h) {
				this._lenX = this._w / this._column;
				this._lenY = this._h / this._row;
			}

			if (obj.regX) this._regX = -(this.lenX * obj.regX);
			if (obj.regY) this._regY = -(this.lenY * obj.regY);

			if (this._bgColor) this._fillGrid(this._bgColor, this._w, this._h);

			// [F] drawGrid
			this._drawGrid(
				this._w,
				this._h,
				this._row,
				this._column,
				this._lenX,
				this._lenY
			);
		}

		// [V] public

		// @DES :: row {num} - 행 갯수
		get row () { return this._row; }

		// @DES :: column {num} - 열 갯수
		get column () { return this._column; }

		// @DES :: lenX {num} - 행 갯수
		get lenX () { return this._lenX; }

		// @DES :: lenY {num} - 행 갯수
		get lenY () { return this._lenY; }

		// [V] protected

		// @DES :: numCellCount {num} - 전체 그리드 갯수
		get _numCellCount () {
			return this._row * this._column;
		}

		// [F] private

		/**
		 * @DES :: Grid-Line-Shpae 만들기
		 * @IP1 :: width {num}
		 * @IP2 :: height {num}
		 * @IP2 :: row {num}
		 * @IP2 :: column {num}
		 * @IP2 :: lenX {num}
		 * @IP2 :: lenY {num}
		 * @S.E :: this._object는 createjs-shape라는 가정이 들어갑니다.
		 */
		_drawGrid (width, height, row, column, lenX, lenY) {
			// [STEP1] 세로 그리드
			for (let i = 0; i < column + 1; i++) {
				this._object.graphics
					.setStrokeStyle(this._lineSize || 1)
					.beginStroke(this._lineColor || B_Define.GRID_COLOR, 'round', 'round')
					.moveTo(lenX * i, 0)
					.lineTo(lenX * i, height);
			}

			// [STEP2] 가로 그리드 (Y증가)
			for (let i = 0; i < row + 1; i++) {
				this._object.graphics
					.setStrokeStyle(this._lineSize || 1)
					.beginStroke(this._lineColor || B_Define.GRID_COLOR, 'round', 'round')
					.moveTo(0, lenY * i)
					.lineTo(width, lenY * i);
			}
		}

		_fillGrid (color, width, height) {
			this._object.graphics
				.beginFill(color)
				.drawRect(0, 0, width, height);
		}

		// [F] public

		/**
		 * @DES :: 그리드 라인을 토글하는 함수
		 * @S.E ::
		 */
		toggleGrid () {
			this._object.visible = !this._object.visible;
		}

		/**
		 * @DES :: 그리드에 포함되는 객체 추가
		 * @IP1 :: countX {num}
		 * @IP2 :: countY {num}
		 * @S.E :: grid-id를 매핑시켜 객체를 생성합니다.
		 */
		addObject (attr) {
			// [*] which grid is included?
			attr.parent = this._id;

			this.CODMOS.WRAPPER.addObject(attr);
		}
	};

export default B_Grid;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/grid/B_Grid.js